import { DocumentService as OvermapDocumentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class DocumentService extends OvermapDocumentService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
